module.exports = __webpack_public_path__ + "static/media/alpi-mobile-screens.0db7cd05.png";